<script lang="ts">
  const { poolType } = $props();

  const badgeColors: Record<string, string> = {
    PumpSwapAmm: "text-[#ff6b9d] border-[#ff6b9d]/30",
    PumpFunAmm: "text-[#00d18c] border-[#00d18c]/30",
    RaydiumAmm: "text-[#6c5ce7] border-[#6c5ce7]/30",
    RaydiumCpmm: "text-[#8b7cf7] border-[#8b7cf7]/30",
    RaydiumClmm: "text-[#a39af7] border-[#a39af7]/30",
    RaydiumLaunchpad: "text-[#5b4cd6] border-[#5b4cd6]/30",
    MeteoraDyn: "text-[#f5a623] border-[#f5a623]/30",
    MeteoraDynV2: "text-[#f7b84e] border-[#f7b84e]/30",
    MeteoraDlmm: "text-[#e8961c] border-[#e8961c]/30",
  };

  const colors = badgeColors[poolType] || "text-gray-400 border-gray-600";
</script>

<span class="badge badge-xs badge-outline rounded-none font-mono text-[9px] uppercase tracking-widest {colors}">{poolType}</span>
